import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TasksSelectors, TasksDispatchers, ClientsSelectors, AuthSelectors, SessionSelectors } from '@store';
import { Task, TaskComment } from '@store/models';

@Component({
    selector: 'app-samtalelog',
    template: `
        <app-samtalelog-ui
            [userCard]="userCard$ | async"
            [samtalelogs]="samtalelogs$ | async"
            [users]="users$ | async"
            [clients]="clients$ | async"
            (clientClick)="clientClick($event)"
            (deleteTask)="deleteTask($event)"
            (saveTaskComment)="saveTaskComment($event)"
            (dismiss)="dismiss()"
        ></app-samtalelog-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SamtalelogContainer implements OnInit {

    userCard$ = this.authSelector.userCard$;
    samtalelogs$ = this.tasksSelector.notificationTasks$;
    users$ = this.sessionSelector.users$(new Date());
    clients$ = this.clientsSelector.allClients$;

    constructor(
        private router: Router,
        private authSelector: AuthSelectors,
        private tasksSelector: TasksSelectors,
        private tasksDispatch: TasksDispatchers,
        private clientsSelector: ClientsSelectors,
        private sessionSelector: SessionSelectors,
        public activeModal: NgbActiveModal
    ) {}

    ngOnInit() {
        this.tasksDispatch.loadNotificationTasks();
    }

    clientClick(kid: number) {
        this.router.navigate(['/clients', kid]);
        this.activeModal.close();
    }

    deleteTask(task: Task) {
        this.tasksDispatch.updateTask(task);
    }

    saveTaskComment(taskComment: TaskComment) {
        this.tasksDispatch.createTaskComment(taskComment);
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
